import request from "../request";

export default {
  //折线-添加
  add(data) {
    return request.post("/points/add", data);
  },

  //折线-修改
  edit(data) {
    return request.post("/points/edit", data);
  },

  //折线-删除
  delete(data) {
    return request.post("/points/delete", data);
  },

  //折线-列表
  lists(data) {
    return request.get("/points/lists", data);
  },

  //折线-列表
  newLists(data) {
    return request.get("/points/newLists", data);
  },

  // 状态流转
  takeTurn(data) {
    return request.post("/points/takeTurn", data);
  }
};
